import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Twitch } from 'lucide-react';
import { GAME_COSTS, FEATURED_GAMES, STANDARD_GAMES, STANDARD_GAMES_LINK } from './GameData';

export const ContestantSection = () => (
  <section className="py-12 sm:py-16 px-4 bg-gradient-to-b from-transparent via-blue-900/20 to-transparent">
    <div className="max-w-7xl mx-auto">
      <ContestantHeader />
      <GamesCard />
    </div>
  </section>
);

const ContestantHeader = () => (
  <div className="text-center mb-8">
    <h2 className="text-4xl sm:text-5xl md:text-6xl font-black game-show-text mb-4">
      BE A CONTESTANT
    </h2>
    <p className="text-xl sm:text-2xl text-blue-300 font-bold mb-4">
      Watch 5 minutes = Earn 1 point
    </p>
    <p className="text-lg sm:text-xl text-gray-200 font-black">
      Play to win Amazon $5 Gift Cards!
    </p>
  </div>
);

const GamesCard = () => (
  <Card className="bet-card border-4 max-w-6xl mx-auto">
    <CardContent className="p-4 sm:p-6">
      <h3 className="text-xl sm:text-2xl font-black text-blue-400 mb-4 text-center">
        Type These Commands in Chat:
      </h3>
      <GamesGrid />
      <StartPlayingButton />
    </CardContent>
  </Card>
);

const GamesGrid = () => (
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
    {FEATURED_GAMES.map((game) => (
      <FeaturedGameCard key={game.id} game={game} />
    ))}
    {STANDARD_GAMES.map((game) => (
      <StandardGameCard key={game.id} game={game} />
    ))}
  </div>
);

const StartPlayingButton = () => (
  <div className="text-center mt-6">
    <a 
      href="https://www.twitch.tv/cirogameshowtwitch"
      target="_blank"
      rel="noopener noreferrer"
      className="inline-block"
    >
      <Button 
        size="lg" 
        className="text-xl font-black py-6 px-8 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-500 hover:to-blue-600 border-4 border-blue-400 pulse-button"
      >
        <Twitch className="mr-3 w-6 h-6" />
        START PLAYING IN CHAT
      </Button>
    </a>
  </div>
);

const FeaturedGameCard = ({ game }) => (
  <a 
    href={game.link}
    target="_blank"
    rel="noopener noreferrer"
    className="contestant-game-card p-3 rounded-lg border-2 border-blue-500/50 bg-gradient-to-r from-blue-900/30 to-slate-800/30 block hover:border-blue-400 transition-all"
  >
    <h4 className="text-lg font-black text-white mb-1">{game.cmd}</h4>
    <p className="text-gray-300 text-xs mb-2">{game.win}</p>
    <GameStats cost={game.cost} cooldown={game.cooldown} winRate={game.winRate} />
  </a>
);

const StandardGameCard = ({ game }) => (
  <a 
    href={STANDARD_GAMES_LINK}
    target="_blank"
    rel="noopener noreferrer"
    className="contestant-game-card p-3 rounded-lg border-2 border-gray-500/50 bg-gradient-to-r from-slate-800/30 to-gray-800/30 block hover:border-gray-400 transition-all"
  >
    <h4 className="text-lg font-black text-white mb-1">{game.cmd}</h4>
    <p className="text-gray-300 text-xs mb-2">{game.win}</p>
    <GameStats cost={GAME_COSTS.STANDARD} cooldown="30 mins" winRate=".41%" />
  </a>
);

const GameStats = ({ cost, cooldown, winRate }) => (
  <div className="flex flex-wrap gap-2 text-xs">
    <span className="text-blue-400 font-bold">Cost: {cost}</span>
    <span className="text-gray-400">|</span>
    <span className="text-gray-300">{cooldown}</span>
    <span className="text-gray-400">|</span>
    <span className="text-emerald-400 font-bold">Win: {winRate}</span>
  </div>
);
